module.exports = __webpack_public_path__ + "static/media/jayla-lavender-nicholas.fa516b36.md";